export enum RepresentativeType {
  LEARNING_TECHNOLOGY_REPRESENTATIVE = 'Learning Technology Representative',
  CUSTOMER_SUCCESS_REPRESENTATIVE = 'Customer Success Representative',
  ALEKS_IMPLEMENTATION_MANAGER = 'ALEKS Implementation Manager',
  ENTERPRISE_ACCOUNT_MANAGER = 'Enterprise Account Manager',
}

export interface AreasOfInterest {
  group: string;
  areas: string;
}